import { Stack } from '@mui/material';
import { usePDF } from 'react-to-pdf';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';

import { Strings } from '@app/constants';
import { useDialog } from '@app/hooks';
import { Header } from '@app/sections/header';
import { IOfferLetter } from '../../type';
import OfferLetter from './offer-letter';
import Terms from '../terms';
import OfferLetterDetailDialog from './offer-letter-detail-dialog';
import JoiningDetails from './joining-details';

const OfferLetterPage = () => {
  const offerLetterDetailsDialog = useDialog();

  const methods = useForm<IOfferLetter>({
    defaultValues: {
      fullName: '',
      joiningDate: dayjs().toISOString(),
      address: '',
      position: '',
      monthlySalary: '',
      contraction: '',
    },
  });

  const { toPDF, targetRef } = usePDF({ filename: 'offer-letter.pdf' });

  const printPDF = () => {
    toPDF({ method: 'build', overrides: { pdf: { unit: 'em' } } });
  };

  return (
    <>
      <Header
        title={Strings.page_title.offerLetter}
        helperText={''}
        actionButtonTitle={Strings.button.updateInfo}
        onClickActionButton={offerLetterDetailsDialog.show}
        additionalButtonTitle={Strings.button.downloadPdf}
        onClickAdditionalButton={printPDF}
      />

      <Stack overflow="scroll" py={2}>
        <Stack
          width={'795px'}
          margin="auto"
          sx={{ boxShadow: '0 0 4px 2px rgba(0, 0, 0, 0.2)' }}
          ref={targetRef}
        >
          <OfferLetter methods={methods} />
          <JoiningDetails methods={methods} />
          <Terms />
        </Stack>
      </Stack>

      {offerLetterDetailsDialog.visible && (
        <OfferLetterDetailDialog
          methods={methods}
          open={offerLetterDetailsDialog.visible}
          onClose={offerLetterDetailsDialog.hide}
        />
      )}
    </>
  );
};

export { OfferLetterPage };
